import 'lazysizes';
import InfiniteScroll from './components/infiniteScroll.js';
import Modal from './components/modal.js';
//import Navigation from './components/navigation.js';
import Slider from './components/slider.js';
//import Parallax from './components/parallax.js';
import Loader from './components/loader.js';
import Search from './components/search.js';
import Split from './components/split.js';
import Toggle from './components/toggle.js';
import Scroll from './components/scroll.js';
//import Cursor from './components/cursor.js';
import gdprCompliance from './components/gdprCompliance.js';

const gdprcompliance = new gdprCompliance();
const infiniteScroll = new InfiniteScroll;
const search = new Search();
const loader = new Loader;
const modal = new Modal();
//const navigation = new Navigation;
const sliderPrimary = new Slider('.js-slider-primary', {
	slidesPerView: 2,
	spaceBetween: 0,
	breakpoints: {
		// Caution: No mobile first - when window width is <= 320px
		480: {
			slidesPerView: 1
		},
		768: {
			slidesPerView: 1
		},
		992: {
			slidesPerView: 1
		}
	}
});
const sliderSecondary = new Slider('.js-slider-secondary', {
	effect: 'fade',
	speed: 1000
});

const sliderTertiary = new Slider('.js-slider-tertiary', {
	effect: 'slide',
	loop: false,
	speed: 1000
});

const carousel = new Slider('.js-carousel', {
	loop: false,
	breakpointsInverse: true,
	//slidesPerView: 2,
	slidesPerView: 'auto',
	spaceBetween: 48,
	//freeMode: true,
	grabCursor: true,
	scrollbarHide: true,
	mousewheel: true,
	//freeModeSticky: true,
	breakpoints: {
		// when window width is >= xs
		480: {
			slidesPerView: 1,
			//slidesPerView: 'auto',
			//freeMode: true,
			spaceBetween: 48
		},
		// when window width is >= sm
		768: {
			slidesPerView: 3,
			//freeMode: false,
			spaceBetween: 48
		},
		// when window width is >= md
		992: {
			slidesPerView: 4,
		},
		// when window width is >= lg
		1200: {
			slidesPerView: 5,
			spaceBetween: 72
		},
		// when window width is >= xl
		1440: {
			slidesPerView: 7,
			spaceBetween: 72
		}
	}

	/*breakpoints: {
		// Caution: No mobile first - when window width is <= 320px
		480: {
			slidesPerView: 2
		},
		768: {
			slidesPerView: 2
		},
		992: {
			slidesPerView: 3
		},
		1300: {
			slidesPerView: 3
		},
		1600: {
			slidesPerView: 4
		}
	}*/
});

const carouselSmall = new Slider('.js-carousel-small', {
	slidesPerView: 2,
	spaceBetween: 0,
	loop: true,
	freeMode: true,
	breakpointsInverse: true,
	breakpoints: {
		768: {
			slidesPerView: 3
		},
		992: {
			slidesPerView: 3
		}
	}
});

const split = new Split();
const toggle = new Toggle();
const scroll = new Scroll();
//const parallax = new Parallax('.js-parallax');
//const cursor = new Cursor();